import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { partnerBundleEnvironment } from '../partner-bundle-environment';
import { bundleSchema } from '../schemas/bundle.schema';
import { z } from 'zod/v4';
import { fromFetch } from 'rxjs/fetch';

/**
 * Returns an array of bundles
 * @param partnerId The partner ID
 * @param alias The account alias
 * @returns Bundles
 */
export function getBundlesPartnerAccount(
  this: unknown,
  alias: string,
  accountId: string
) {
  const requestUrl = `${partnerBundleEnvironment.resolve(this).bundlesPartnerAccount(alias, accountId)}`;

  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(requestUrl, {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
      })
    )
  ).pipe(selectData(z.array(bundleSchema)));
}
